import {computed} from "mobx";

import {BaseViewModel} from "../../../infrastructure/models/base-view-model";
import {PartialGameViewModel} from "../../../domain/partial-game/models/partial-game-view-model";
import {GAME_STATUSES} from "../../../core/app/consts";
import {CompetitionViewModel} from "../../common/competition/models/competition-view-model";
import {PartialGameDataSource} from "./partial-game-data-source";
import {PagingModel} from "../../../infrastructure/models/paging/paging.model";

export class PartialGamesViewModel extends BaseViewModel {
  games: Array<PartialGameViewModel>;
  paging: PagingModel;

  constructor(model: PartialGameDataSource, games: Array<PartialGamesViewModel> = []) {
    super();

    this.paging = model.paging;
    this.games = [];
    this.games.push(...games)
  }

  @computed get liveGamesCount(): Number {
    return this.games.filter((g: PartialGameViewModel) => g.statusGroup === GAME_STATUSES.started).length;
  }

  get competitions(): Array<CompetitionViewModel> {
    const competitionsData = {};

    this.games.forEach((game: PartialGameViewModel) => {
      if (!competitionsData[game.competition.id]) {
        competitionsData[game.competition.id] = game.competition
      }
    });

    return Object.values(competitionsData);
  }

}
